import { render, staticRenderFns } from "./employee-form.vue?vue&type=template&id=8a535bb6&scoped=true&"
import script from "./employee-form.vue?vue&type=script&lang=js&"
export * from "./employee-form.vue?vue&type=script&lang=js&"
import style0 from "./employee-form.vue?vue&type=style&index=0&id=8a535bb6&lang=scss&scoped=true&"
import style1 from "./employee-form.vue?vue&type=style&index=1&id=8a535bb6&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a535bb6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8a535bb6')) {
      api.createRecord('8a535bb6', component.options)
    } else {
      api.reload('8a535bb6', component.options)
    }
    module.hot.accept("./employee-form.vue?vue&type=template&id=8a535bb6&scoped=true&", function () {
      api.rerender('8a535bb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/employees/employee-form.vue"
export default component.exports